import type { FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
};
const Title: FC<Props> = (props) => {
  const { children } = props;

  return <div className="title">{children}</div>;
};

export default Title;
